export enum leaderModals {
  INVITE_RAFFLE = 'INVITE_RAFFLE',
  PURCHASE = 'PURCHASE',
}
